import Cookies from 'universal-cookie';

const TOKEN_STORAGE_KEY = 'token';
const LOGGED_OUT_STORAGE_KEY = 'LOGGED_OUT';
const TOKEN_COOKIE_KEY = 'token';
const LOGGED_OUT_COOKIE_KEY = 'logged_out';


const isBrowser = typeof window !== 'undefined';
const isWebView = () => {
  if (!isBrowser) return false;
  return Boolean(window.ReactNativeWebView);
};

const getSecureFlag = () => {
  if (!isBrowser) return true;
  return window.location.protocol === 'https:';
};

const getCookieWriteOptions = () => ({
  path: '/',
  maxAge: 60 * 60 * 24,
  secure: getSecureFlag(),
  sameSite: 'lax',
});

export const persistAuthToken = (token) => {
  if (!isBrowser || !token) return;



//   const cookies = new Cookies();
//   cookies.set(TOKEN_COOKIE_KEY, token, getCookieWriteOptions());

//   // if (isBrowser) {
//     window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
//   // }
// };

  const cookies = new Cookies();
  if (!isWebView()) {
    cookies.set(TOKEN_COOKIE_KEY, token, getCookieWriteOptions());
    cookies.remove(LOGGED_OUT_COOKIE_KEY, { path: '/' });
    cookies.remove(LOGGED_OUT_COOKIE_KEY, {
      path: '/',
      secure: getSecureFlag(),
      sameSite: 'lax',
    });
  }

  window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  window.localStorage.removeItem(LOGGED_OUT_STORAGE_KEY);
};

export const getAuthToken = () => {
  if (!isBrowser) return null;

  if (!isBrowser) return null;

  // 🔥 BLOCK AFTER LOGOUT
  const isLoggedOut = localStorage.getItem('LOGGED_OUT');
  const cookies = new Cookies();
  const isLoggedOutCookie = cookies.get(LOGGED_OUT_COOKIE_KEY);

  if (isLoggedOut === 'true') {
    return null;
  }

  if (isWebView()) {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY);
  }

  if (isLoggedOutCookie === 'true') {
    return null;
  }

  const cookieToken = cookies.get(TOKEN_COOKIE_KEY);

  if (cookieToken) return cookieToken;

  // return localStorage.getItem(TOKEN_STORAGE_KEY);



  if (window.localStorage.getItem(LOGGED_OUT_STORAGE_KEY) === 'true') {
    return null;
  }

  return window.localStorage.getItem(TOKEN_STORAGE_KEY);
};

export const clearAuthToken = () => {
  if (!isBrowser) return;

 const cookies = new Cookies();
  const secureVariants = [true, false];
  const sameSiteVariants = ['lax', 'strict', 'none'];

  cookies.remove(TOKEN_COOKIE_KEY, { path: '/' });

  if (!isWebView()) {
    for (const secure of secureVariants) {
      cookies.remove(TOKEN_COOKIE_KEY, { path: '/', secure });
      cookies.remove(TOKEN_COOKIE_KEY, {
        path: '/',
        secure,
        sameSite: 'lax',
      });

      for (const sameSite of sameSiteVariants) {
        cookies.remove(TOKEN_COOKIE_KEY, { path: '/', secure, sameSite });
      }
    }
  }

  window.localStorage.setItem(LOGGED_OUT_STORAGE_KEY, 'true');
  if (!isWebView()) {
    cookies.set(LOGGED_OUT_COOKIE_KEY, 'true', getCookieWriteOptions());
  }
  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  window.sessionStorage.clear();
};



// import Cookies from 'universal-cookie';

// const TOKEN_COOKIE_KEY = 'token';
// const TOKEN_STORAGE_KEY = 'token';

// const isBrowser = typeof window !== 'undefined';

// const getSecureFlag = () => {
//   if (!isBrowser) return true;
//   return window.location.protocol === 'https:';
// };

// const getCookieWriteOptions = () => ({
//   path: '/',
//   maxAge: 60 * 60 * 24,
//   secure: getSecureFlag(),
//   sameSite: 'lax',
// });

// export const persistAuthToken = (token) => {
//   if (!token) return;

//   const cookies = new Cookies();
//   cookies.set(TOKEN_COOKIE_KEY, token, getCookieWriteOptions());

//   // if (isBrowser) {
//     window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
//   // }
// };

// export const getAuthToken = () => {
//   // const cookies = new Cookies();
//   // const cookieToken = cookies.get(TOKEN_COOKIE_KEY);

//   // if (cookieToken) return cookieToken;
//   // // if (!isBrowser) return null;

//   // // return window.localStorage.getItem(TOKEN_STORAGE_KEY);



//   if (!isBrowser) return null;

//   // 🔥 BLOCK AFTER LOGOUT
//   const isLoggedOut = localStorage.getItem('LOGGED_OUT');

//   if (isLoggedOut === 'true') {
//     return null;
//   }

//   const cookies = new Cookies();
//   const cookieToken = cookies.get(TOKEN_COOKIE_KEY);

//   if (cookieToken) return cookieToken;

//   return localStorage.getItem(TOKEN_STORAGE_KEY);

// };

// // export const getAuthToken = () => {

// //   if (!isBrowser) return null;

// //   return window.localStorage.getItem(TOKEN_STORAGE_KEY);

// // };

// export const clearAuthToken = () => {
//   const cookies = new Cookies();
//   const secureVariants = [true, false];
//   const sameSiteVariants = ['lax', 'strict', 'none'];

//   for (const secure of secureVariants) {
//     cookies.remove(TOKEN_COOKIE_KEY, { path: '/', secure });

//     for (const sameSite of sameSiteVariants) {
//       cookies.remove(TOKEN_COOKIE_KEY, { path: '/', secure, sameSite });
//     }
//   }

//   if (isBrowser) {
//     window.localStorage.removeItem(TOKEN_STORAGE_KEY);
//     window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
//   }
// };
